module.exports = __webpack_public_path__ + "img/Of-Course-Bigger-The-Better.e810e7aa.jpg";